import { getThemeClass, getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function Card({ children, className = "" }: Props) {
  const cardClasses = getThemeComponentClasses().card;

  return (
    <div
      className={`${getThemeClass(cardClasses.bgColor, "bg-theme-surface")} rounded-3xl border ${getThemeClass(cardClasses.borderColor, "border-theme-border")} ${cardClasses.base} ${className}`}
    >
      {children}
    </div>
  );
}
